import { combineReducers } from 'redux';
// import { connectRouter } from 'connected-react-router';
import booking from './booking';
import app from './app';

export default combineReducers({
	bookingReducer: booking,
	app,
});
